var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14.9333C18 15.9643 17.1941 16.8 16.2 16.8H1.8C0.805888 16.8 0 15.9643 0 14.9333V8.20843L0.0727696 8.03234L2.79213 1.45531C3.19772 0.598655 3.70929 0.0681392 4.5 0H13.5L13.6177 0.00802104C14.2953 0.100741 14.7916 0.615396 15.2272 1.49901L18 8.20843V14.9333ZM1.8 9.33333V14.9333H16.2V9.33333H12.6C12.6 10.3643 11.7941 11.2 10.8 11.2H7.2C6.20589 11.2 5.4 10.3643 5.4 9.33333H1.8ZM2.26489 7.46667H7.2V9.33333H10.8V7.46667H15.7356L13.5996 2.29347C13.4988 2.09015 13.4058 1.94744 13.3306 1.8666L4.65833 1.86315C4.58883 1.94083 4.50299 2.07694 4.42723 2.23432L2.26489 7.46667Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiv);
export default __webpack_public_path__ + "static/media/archiv.c50cee06b2d85ed859998bd26c60efb3.svg";
export { ForwardRef as ReactComponent };